export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
